import base from "../../base.js";
import rotationDefinition from "../../definition/rotation.js";
import positionItem from "../position.js";
import vueStore from "../../../config.js";
import * as namespaceStore from "../../../namespaceStore.js";
import imageFormat from "../../definition/imageFormat.js";
import alignementHorizontalDefinition from "../../definition/alignementHorizontal.js";
import fontWeightDefinition from "../../definition/fontWeight.js";
import opencvService from "../../../../utils/opencvService.js";
import filterCreator from "./filter/creator.js";
import { reactive, unref } from 'vue'
import previewList from "../../definition/previewList.js";

export default class PlanBase extends base {
    objectType = "PlanBaseItem";
    Position = null;
    Rotation = 0;
    _Filters = []; // class list of filters
    Format = undefined;
    _Preview = "/assets/images/4_m.png";
    CameraId = 0;
    TriggerOrder = 0;
    TriggerDelay = 4;
    _Text = "";
    textColor = "#FF000000";
    textShadowColor = "#98000000";
    textShadowOffsetX = 0;
    textShadowOffsetY = 0;
    textShadowStrokeWidth = 0;
    TextPolice = "Great Vibes";
    textFontSize = 58;
    textFontStyle = "Regular";
    textAlignment = "Center";
    _Path = null;
    _PathComputedFromFilters = null; // image en cache après application des filtres

    constructor(args = {}) {
        super(args);
    }

    objectToClassValue(args = {}) {
        args = this.constructor.fromObjectToObject(args);
        if (args.position) {
            args.position = positionItem.fromObject({...args.position, maxSizeX: -1, maxSizeY: -1});
        }
        else {
            args.position = positionItem.fromObject({maxSizeX: -1, maxSizeY: -1});
        }
        if (args.filters) {
            args.filters = args.filters.filter(f => typeof f === 'object' && !Array.isArray(f) && f !== null).map(f => filterCreator(f.objectType, f));
        }
        args.canBeDuplicate = false;
        super.objectToClassValue(args);
        this.Position = args.position ? args.position : null;
        if (this.Position) {
            this.Position.maxSizeX = this.maxSizeX;
            this.Position.maxSizeY = this.maxSizeY;
        }
        if (args.rotation != null && args.rotation == "None")
            args.rotation = "NONE";
        this.Rotation = args.rotation ? this.getIdFromText(args.rotation, rotationDefinition) : this.getIdFromText("NONE", rotationDefinition);
        this.Filters = args.filters ? args.filters : [];
        this.CameraId = args.cameraId ? args.cameraId : 0;
        this.TriggerOrder = args.triggerOrder ? args.triggerOrder : 0;
        this.TriggerDelay = args.triggerDelay ? args.triggerDelay : 4;
        this.Format = args.format ? this.getIdFromText(args.format, imageFormat): this.getIdFromText("Rempli", imageFormat);
        this._Text = args.text ? args.text : "Votre texte ici";
        this.TextColor = args.textColor ? args.textColor : "#000000";
        this.TextShadowColor = args.textShadowColor ? args.textShadowColor : "#98000000";
        this.TextShadowOffsetX = args.textShadowOffsetX ? args.textShadowOffsetX : 0;
        this.TextShadowOffsetY = args.textShadowOffsetY ? args.textShadowOffsetY : 0;
        this.TextShadowStrokeWidth = args.textShadowStrokeWidth ? args.textShadowStrokeWidth : 0;
        this.TextPolice = args.textPolice ? this.getIdFromText(args.textPolice, vueStore.getters[namespaceStore.THEME + "/ressourcesByType"]("font")) : vueStore.getters[namespaceStore.THEME + "/firstRessourceByType"]("font").idSoft;
        this.TextFontSize = args.textFontSize ? args.textFontSize : 58;
        this.TextFontStyle = args.textFontStyle ? this.getIdFromText(args.textFontStyle, fontWeightDefinition) : this.getIdFromText("Regular", fontWeightDefinition);
        this.TextAlignment = args.textAlignment ? this.getIdFromText(args.textAlignment, alignementHorizontalDefinition) : this.getIdFromText("Center", alignementHorizontalDefinition);
        this._Preview = args.preview ? this.getIdFromText(args.preview, previewList) : this.getIdFromText("/assets/images/4_m.png", previewList);
        if (args.objectType == "ImagePlanItem") {
            this._Path = args.path ? this.getIdFromText(args.path, vueStore.getters[namespaceStore.THEME + "/ressourcesByType"]("image")) : null;
        }
        else if (args.objectType == "VideoPlanItem") {
            this._Path = args.path ? this.getIdFromText(args.path, vueStore.getters[namespaceStore.THEME + "/ressourcesByType"]("video")) : null;
        }
    }

    set Preview(value) {
        this._Preview = value;
        this.invalidateFilterCache();
    }

    get Preview() {
        return this._Preview;
    }

    get PreviewName() {
        const preview = previewList.find(preview => preview.idSoft == this.Preview);
        if (preview) {
            return preview.name;
        }
        return null;
    }

    get PreviewValue() {
        return previewList.find(preview => preview.idSoft == this.Preview).value;
    }

    get RotationName() {
        return rotationDefinition.find(el => el.idSoft == this.Rotation).name;
    }

    get RotationValue() {
        return rotationDefinition.find(el => el.idSoft == this.Rotation).value;
    }

    get TextFontStyleName() {
        return fontWeightDefinition.find(el => el.idSoft == this.TextFontStyle).name;
    }

    get FormatName() {
        const format = imageFormat.find(format => format.idSoft == this.Format);
        return format.name;
    }

    get TextAlignmentName() {
        const alignment = alignementHorizontalDefinition.find(alignment => alignment.idSoft == this.TextAlignment);
        if (alignment) {
            return alignment.name;
        }
        return "Center";
    }

    get TextAlignmentAlignement() {
        const alignment = alignementHorizontalDefinition.find(alignment => alignment.idSoft == this.TextAlignment);
        if (alignment) {
            return alignment.alignement;
        }
        return "center";
    }

    get TextPoliceDirectory() {
        return this.TextPolice;
    }

    get TextPoliceDesc() {
        const ressource = vueStore.getters[namespaceStore.THEME + "/ressourceByIDSoft"](this.TextPolice);
        if (ressource) {
            return ressource.description;
        }
        return this._textPolice;
    }
    
    get TextPoliceName() {
        const ressource = vueStore.getters[namespaceStore.THEME + "/ressourceByIDSoft"](this.TextPolice);
        if (ressource) {
            return ressource.name;
        }
        return this._textPolice;
    }

    // Getter et setter pour Filters avec surveillance des modifications
    get Filters() {
        return this._Filters;
    }

    set Filters(value) {
        // Supprimer complètement la réactivité
        if (this._Filters) {
            this._Filters = unref(this._Filters);
        }
        this._Filters = reactive(value);
        this.invalidateFilterCache();
    }

    dispose() {
        // Supprimer complètement la réactivité
        if (this._Filters) {
            this._Filters = unref(this._Filters);
        }
        super.dispose();
    }

    swapArrayElement(index, move) {
        if (index < 0 || index > this._Filters.length) return;
        this._Filters.splice(index + move, 0, this._Filters.splice(index, 1)[0]);
    }

    // Méthode privée pour supprimer le cache de l'image filtrée
    _resetComputedPath() {
        this._PathComputedFromFilters = null;
    }

    // Méthode pour forcer la suppression du cache de l'image filtrée
    invalidateFilterCache() {
        this._resetComputedPath();
    }

    get maxSizeX() {
        if (this.parent && this.parent.Size) {
            return this.parent.Size.width;
        }
        return -1;
    }

    get maxSizeY() {
        if (this.parent && this.parent.Size) {
            return this.parent.Size.height;
        }
        return -1;
    }

    removeFromPlan(previewId) {
        if (this._Filters) {
            return this._Filters.some((filter, index) => {
                if (filter.previewId == previewId) {
                    this._Filters.splice(index, 1);
                    return true;
                }
                return false;
            });
        }
        return false;
    }

    getCompositionElementById(id) {
        if (id == this.previewId) {
            return this;
        }
        return null;
    }

    MaxSizeUpdated(beforeWidth = this.maxSizeX, beforeHeight = this.maxSizeY) {
        let ActualPositionX = this.Position.x / beforeWidth;
        let ActualPositionY = this.Position.y / beforeHeight;
        let ActualSizeX = this.Position.width / beforeWidth;
        let ActualSizeY = this.Position.height / beforeHeight;


        this.Position.maxSizeX = this.maxSizeX;
        this.Position.maxSizeY = this.maxSizeY;
        this.Position._width = ActualSizeX * this.maxSizeX;
        this.Position._height = ActualSizeY * this.maxSizeY;
        this.Position._x = ActualPositionX * this.maxSizeX;
        this.Position._y = ActualPositionY * this.maxSizeY;
    }

    async getFilteredPathAsync(defaultPath = null, force = false) {
        const ressource = defaultPath == null ? this.Path : defaultPath;
        if (ressource) {
            if (this.Filters && this.Filters.length > 0) {
                // Vérifier si on a déjà calculé le chemin filtré
                if (this._PathComputedFromFilters != null && force == false) {
                    return this._PathComputedFromFilters;
                }
                try {
                    this._PathComputedFromFilters = await opencvService.applyFilters(ressource, this.Filters);
                    return this._PathComputedFromFilters;
                } catch (error) {
                    console.error("Erreur lors de l'application des filtres:", error);
                    return ressource;
                }
            }
            return ressource;
        }
        return this.Path;
    }

    get Path() {
        const ressource = vueStore.getters[namespaceStore.THEME + "/ressourceByIDSoft"](this._Path);
        if (ressource) {
            return ressource.url;
        }
        return this._Path;
    }

    set Path(value) {
        this.invalidateFilterCache();
        this._Path = value;
    }

    set Text(value) {
        this._Text = value;
    }
    get Text() {
        const ressource = vueStore.getters[namespaceStore.THEME + "/ressourceByName"](this._Text);
        if (ressource) {
            return ressource.text;
        }
        return this._Text;
    }

    static get Name() {
        return "Plan Base";
    }

    get changeableProperty() {
        const parentProperty = super.changeableProperty;
        return [
            ...parentProperty.filter(el => el.type != "objectInput" && el.type != "arrayInput"),
            { name: "Position", type: "objectInput", dataType: "object", options: positionItem },
            { name: "Rotation", type: "selectInput", dataType: "string", optionsType: "idSoft", options: rotationDefinition },
            ...parentProperty.filter(el => el.type == "objectInput" || el.type == "arrayInput")
        ];
    }

    getStyle(currentElementIndex = null) {
        let style = {
            ...super.getStyle(currentElementIndex),
            ...this.getPosition({}),
            rotation: this.RotationName,
        }
        return style;
    }

    getPosition(style) {
        const size = {
            width: this.Position.width,
            height: this.Position.height,
        };
        const r = rotationDefinition.find(rotation => rotation.idSoft == this.Rotation);
        if (r) {
            style = r.action(size, style);
        }
        return style;
    }

    getStyleOnlyPosition(currentElementIndex = null) {
        return {
            position: 'absolute',
            left: this.Position.x + "px",
            top: this.Position.y + "px",
            width: this.Position.width + "px",
            height: this.Position.height + "px",
        }
    }

    static variableOfInstance() {
        return [
            ...super.variableOfInstance(),
            { property: "Position", construct: positionItem, jsType: "Class" },
            { property: "Rotation", construct: Number, jsType: "Number" }
        ];
    }

    static fromObject(object = {}) {
        return new this.prototype.constructor(object);
    }

    toExportObject(variableArray = [], ressourceArray = []) {
        return {
            ...super.toExportObject(variableArray, ressourceArray),
            position: this.Position ? this.Position.toExportObject(variableArray, ressourceArray) : null,
            rotation: this.RotationValue,
        };
    }

    toObject(minify = false) {
        return {
            ...super.toObject(minify),
            position: this.Position ? this.Position.toObject(minify) : null,
            rotation: this.RotationName,
        };
    }
}